export default {
	dependencies: {
      type: 'array',
      default: [{ name: '', url: '' }]
    },
};
